import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) {
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0)
      generalSvc.logoutUser();

    if (dataSvc.currentExamIndex == -1)
      generalSvc.loginUser();
  }

  ngOnInit() {
    //this.displayQuestionFeedback();
    this.displayQuestionFeedback();
    // this.displayResponseFeedback();
  }

  skipFeedback(){
    this.generalSvc.goToEnetassess();
  }

  displayResponseFeedback(){
    var tableString = "";
    var questions = this.dataSvc.getFeedbackResponses();
    if(questions != null){
      for(var i = 0; i < questions.length; i++){          
          var responses = questions[i].QuestionResponses;
          for(var j = 0; j < responses.length; j++){
            if(responses[j].Feedback == true){
              var qText = questions[i].Question.QuestionText.substring(0, 100);
              var rText = responses[j].Response.AnswerText.substring(0, 100);
              tableString += `<tr style='border-bottom:1px solid #AAA; padding:5px;'>
                <td style='width:50%;'>(` + questions[i].Question.OriginalId + `)Question - ` + (i + 1) + qText + "Response - "  + rText + `</td>      
                <td style='width:50%;'>
                  <textarea class='feedText' rows='2' style='width:90%;'></textarea>
                </td>  
              </tr>`;
            }     
          }             
      }
    }
    
    if(tableString != ""){
      tableString = "<tr><th>Response(s) Flagged for Review</th><th>Feedback</th></tr>" + tableString;
      document.getElementById("flaggedDataResponse").innerHTML = tableString;
    }
    else{
      document.getElementById("flaggedDataResponse").style.display = "none";
    }
  }

  displayQuestionFeedback(){
    var tableString = "";
    var questions = this.dataSvc.getFeedbackResponses();
    if(questions != null){
      for(var i = 0; i < questions.length; i++){ 
        if (questions[i].Feedback == true){
          var qText = questions[i].Question.QuestionText;
          qText = qText.replace(/<img[^>]*>/g,"");
          var questionString = "(" + questions[i].Question.OriginalId + ") Question " + (i + 1) + qText + "Responses - <br/>";

          var responses = questions[i].QuestionResponses;
          for(var j = 0; j < responses.length; j++){
            if(responses[j].Feedback == true){
              var rText = responses[j].Response.AnswerText;
              questionString += rText;
            }
          }

          tableString += `<tr style='border-top: 1px solid #AAA'>
                              <td style='width:50%; padding: 5px 20px;'>` + questionString + `</td>      
                              <td style='width:50%; padding: 5px 20px;'>
                                <textarea class='feedText' rows='5' style='width:90%;' questionId='`+ questions[i].Question.OriginalId +`'></textarea>
                              </td>  
                          </tr>`; 
        }                               
      }
    }
    
    if(tableString != ""){
      tableString = "<tr><th>Question(s) Flagged for Review</th><th>Feedback</th></tr>" + tableString;
      document.getElementById("flaggedData").innerHTML = tableString;
    }
    else{
      document.getElementById("flaggedData").style.display = "none";
    }
  }

  submitFeedback(){
    var textareas = document.querySelectorAll("textarea");
    //console.log(textareas);
    var overallFeedback = "";
    for (let i = 0; i < textareas.length; ++i)
    {
      var textArea = textareas[i];
      var title = textArea.getAttribute("questionId");
      var value = textArea.value.toString();

      if (title.length > 0 && value.length > 0)
      {
        if (overallFeedback != "")
          overallFeedback += "<br/>";

        if (i+1 == textareas.length)
          overallFeedback += "<br/>";

        overallFeedback += title + " - " + value;
      }
    }
    //console.log(overallFeedback);
    
    if(overallFeedback !== "")
    {
      overallFeedback = overallFeedback.replace("'", "");  
      this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.Feedback = overallFeedback;
      var sessionId = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.SessionId;
      this.dataSvc.submitFeedback(sessionId, overallFeedback);
    }    
  }
}
